import React, { useState } from 'react'
import { Modal, TextField } from '@ann/web-components'
import { observer } from 'mobx-react';
import { useDrivesStores } from '../../hook/use-drives.hook';
import {useToast} from "../../../../../components/toast";
import { ErrorMessage } from './NewFolderModal.styled';

const NewFolderModal = ({
                           size="medium",
                           modalWidth= '500px',
                           isOpen,
                           onClose,
                           onSave,
                           driveId,
                           disabled = false,
                           vaultUuid = "",
                           folderParentUuid = "",
                           store = null, // Optional store prop for DriveWorkspaceStore
                       }) => {
    const {myWorkspacesStore} = useDrivesStores();
    const [folderName, setFolderName] = useState('');
    const [isCreating, setIsCreating] = useState(false);
    const [touched, setTouched] = useState(false);
    const toast = useToast();
    
    // Use provided store or fallback to myWorkspacesStore for backward compatibility
    const targetStore = store || myWorkspacesStore;
    
    const isFieldEmpty = !folderName.trim();
    const showError = touched && isFieldEmpty;


    const handleSave = async () => {
        try {
            setIsCreating(true);
            
            // Determine vault_uuid: use provided vaultUuid, or get from store
            let finalVaultUuid = vaultUuid;
            if (!finalVaultUuid) {
                if (store) {
                    // For DriveWorkspaceStore, vaultUuid is already set in the store
                    finalVaultUuid = store.vaultUuid || '';
                } else {
                    finalVaultUuid = myWorkspacesStore.drivesStore.drives[0]?.id || '';
                }
            }
            
            // Determine parent_folder_uuid: use provided folderParentUuid, or null for root
            let finalParentFolderUuid = folderParentUuid;
            if (!finalParentFolderUuid && !store) {
                // Only use folderList[0] for myWorkspacesStore (backward compatibility)
                finalParentFolderUuid = myWorkspacesStore.folderList[0]?.folder_uuid || '';
            }
            
            const folderData = {
                vault_uuid: finalVaultUuid,
                parent_folder_uuid: finalParentFolderUuid || null, // null for root folder
                description: "New folder",
                name: folderName.trim() || 'Untitled Folder'
            };

            await targetStore.createFolder(folderData);
            
            setFolderName('');
            
            // Call onSave with success result
            if (onSave) {
                onSave({
                    success: true,
                    parentFolderId: folderParentUuid
                });
            }
            
            onClose();
            
        } catch (error) {
            toast.error({ message: "Error creating folder", duration: 2, canClose: true });
            
            // Call onSave with error result
            if (onSave) {
                onSave({
                    success: false,
                    error: error
                });
            }
        } finally {
            setIsCreating(false);
        }
    };

    const handleClose = () => {
        setFolderName('');
        setIsCreating(false);
        setTouched(false);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} width={modalWidth} size={size}>
            <Modal.Header>
                <Modal.Header.Title>
                    New Folder
                </Modal.Header.Title>
            </Modal.Header>
            <Modal.Body>
                <TextField
                    label="Folder Name"
                    size="small"
                    placeholder="Untitled Folder"
                    value={folderName}
                    onChange={(value) => {
                        setFolderName(value);
                        if (!touched && value.length > 0) {
                            setTouched(true);
                        }
                    }}
                    required={true}
                />
                {showError && (
                    <ErrorMessage>Folder name is required</ErrorMessage>
                )}
            </Modal.Body>
            <Modal.Actions align="end">
                <Modal.Button
                    label="Cancel"
                    onClick={handleClose}
                    type="secondary"
                />
                <Modal.Button
                    label={isCreating ? "Creating..." : "Create"}
                    onClick={handleSave}
                    disabled={disabled || isCreating || isFieldEmpty}
                />
            </Modal.Actions>
        </Modal>
    )
}

export default observer(NewFolderModal)